export default "__VITE_ASSET__Givi4k_q__"